import CommonUtils from '@/resources/utils/common-utils'
import API from '@/config/api'
import Common from "./common";

const commonApi = {
    state: {},
    mutations: {
        setCurseSort(state, data) {
            data.url = API.startClass.setCurseSort
            CommonUtils.PostRequest(data)
        },
        getBanners(state, data) {
            data.url = API.startClass.bannerList
            CommonUtils.GetRequest(data)
        },
        getGroups(state, data) {
            data.url = API.startClass.groupList
            CommonUtils.GetRequest(data)
        },
        addCourse(state, data) {
            data.url = API.startClass.addCourse
            CommonUtils.PostRequest(data)
        },
        addCourseBanner(state, data) {
            data.url = API.startClass.addCourseBanner
            CommonUtils.PostRequest(data)
        },
        addCourseGroup(state, data) {
            data.url = API.startClass.addCourseGroup
            CommonUtils.PostRequest(data)
        },
        editCourse(state, data) {
            data.url = API.startClass.editCourse
            CommonUtils.PostRequest(data)
        },
        editCourseBanner(state, data) {
            data.url = API.startClass.editCourseBanner
            CommonUtils.PostRequest(data)
        },
        editCourseGroup(state, data) {
            data.url = API.startClass.editCourseGroup
            CommonUtils.PostRequest(data)
        },
        getCourses(state, data) {
            data.url = API.startClass.courseList
            CommonUtils.GetRequest(data)
        },
        delCourse(state, data) {
            data.url = API.startClass.delCourse
            CommonUtils.PostRequest(data)
        },
        delCourseBanner(state, data) {
            data.url = API.startClass.delCourseBanner
            CommonUtils.PostRequest(data)
        },
        delCourseGroup(state, data) {
            data.url = API.startClass.delCourseGroup
            CommonUtils.PostRequest(data)
        },
        batchDelCourse(state, data) {
            data.url = API.startClass.batchDelCourse
            CommonUtils.PostRequest(data)
        },
        changeRecommend(state, data) {
            data.url = API.startClass.changeRecommend
            CommonUtils.PostRequest(data)
        },
        changeOnSale(state, data) {
            data.url = API.startClass.changeOnSale
            CommonUtils.PostRequest(data)
        },
        batchIsOnSaleCourse(state, data) {
            data.url = API.startClass.batchShelfCourse
            CommonUtils.PostRequest(data)
        },
        getApplicableAge(state, data) {
            data.url = API.startClass.applicableAge
            CommonUtils.GetRequest(data)
        },
        courseAnalysis(state, data) {
            data.url = API.startClass.courseAnalysis
            CommonUtils.GetRequest(data)
        },
        courseAnalysisStatistics(state, data) {
            data.url = API.startClass.courseAnalysisStatistics
            CommonUtils.GetRequest(data)
        },
        analysisStatistics(state, data) {
            data.url = API.startClass.analysisStatistics
            CommonUtils.GetRequest(data)
        },
        analysisStatisticsInfo(state, data) {
            data.url = API.startClass.analysisStatisticsInfo
            CommonUtils.GetRequest(data)
        },
        analysisInfo(state, data) {
            data.url = API.startClass.analysisInfo
            CommonUtils.GetRequest(data)
        },
        questionnaireList(state, data) {
            data.url = API.startClass.questionnaireList
            CommonUtils.GetRequest(data)
        },
        questionnaireDetail(state, data) {
            data.url = API.startClass.questionnaireDetail
            CommonUtils.GetRequest(data)
        },
        questionnaireStatistics(state, data) {
            data.url = API.startClass.questionnaireStatistics
            CommonUtils.GetRequest(data)
        },
        questionnaireAnswerRecord(state, data) {
            data.url = API.startClass.questionnaireAnswerRecord
            CommonUtils.GetRequest(data)
        },
        questionnaireAnswerDetails(state, data) {
            data.url = API.startClass.questionnaireAnswerDetails
            CommonUtils.GetRequest(data)
        },
        getPlayLog(state, data) {
            data.url = API.startClass.getPlayLog
            CommonUtils.GetRequest(data)
        },
        getCourseDetail(state, data) {
            data.url = API.startClass.getCourseDetail
            CommonUtils.GetRequest(data)
        },
        userInternal(state, data) {
            data.url = API.startClass.userInternal
            CommonUtils.GetRequest(data)
        },
        getInternalLink(state, data) {
            data.url = API.startClass.getInternalLink
            CommonUtils.GetRequest(data)
        },
        getAnalysisStatistics(state, data) {
            data.url = API.startClass.getAnalysisStatistics
            CommonUtils.GetRequest(data)
        },
        getChildBehaviorResult(state, data) {
            data.url = API.startClass.getChildBehaviorResult
            CommonUtils.GetRequest(data)
        },
        getChildBehaviorEcho(state, data) {
            data.url = API.startClass.getChildBehaviorEcho
            CommonUtils.GetRequest(data)
        }
    }
}

export default commonApi



// WEBPACK FOOTER //
// ./src/store/modules/startClass.js